<template>
	<div class="pagaing">
		<div
			v-if="pageIndex > 1"
			@click="() => changeHandle(pageIndex - 1)"
			class="page_item"
		>
			&lt;
		</div>
		<template v-for="index in showPages">
			<router-link
				v-if="index !== '...'"
				:class="[
					'page_item',
					pageIndex === index ? 'current' : '',
					'...' === index ? 'not-select' : ''
				]"
				:key="index"
				:to="{ path: $route.path, query: { ...$route.query, page: index }}"
			>
				{{ index }}
			</router-link>
			<div
				v-else
				:class="[
					'page_item',
					pageIndex === index ? 'current' : '',
					'...' === index ? 'not-select' : ''
				]"
				:key="index"
			>
				{{ index }}
			</div>
		</template>
		<div
			v-if="pageIndex < pageCount"
			@click="() => changeHandle(pageIndex + 1)"
			class="page_item"
		>
			&gt;
		</div>
		<router-link :to="{ path: $route.path, query: { ...$route.query, page: this.pageCount }}" class="last-page" @click="goLastPage">
			尾页
		</router-link>
		<div class="total">
			共 {{ total }} 条内容
		</div>
	</div>
</template>
<script>
export default {
	name: 'Pagaing',
	props: {
		total: {
			type: Number,
			default: 0
		},
		pageSize: {
			type: Number,
			default: 6
		},
		pageIndex: {
			type: Number,
			default: 1
		}
	},
	data() {
		return {
			pageCount: 1,
			showPages: [1],
			isBase: false
		};
	},
	watch: {
		'$route.query.page' (val) {
			this.initPages(val)
		}
	},
	mounted() {
		this.getCount();
		this.initPages(this.$route.query.page || 1);
	},
	methods: {
		goLastPage () {
			if (this.$route.query.page == this.pageCount) return
			const route = this.$router.resolve({
				path: this.$route.path,
				query: {
					...this.$route.query,
					page: this.pageCount
				}
			})
			this.$router.push(route.href)
		},
		getCount() {
			this.pageCount = Math.ceil(this.total / this.pageSize);
			this.isBase = this.pageCount <= 6;
			if (this.isBase) {
				const arr = [...new Array(this.pageCount).keys()]
				arr.splice(0, 1)
				this.showPages = arr
			} else {
				this.showPages = [1, 2, 3, 4, 5, '...', this.pageCount];
			}
		},
		initPages (i) {
			this.pageIndex = this.$route.query.page || 1
			if (i === '...') return;
			if (!this.isBase) {
				if (i > 4) {
					if (this.pageCount - i < 4) {
						this.showPages = [
							1,
							'...',
							this.pageCount - 4,
							this.pageCount - 3,
							this.pageCount - 2,
							this.pageCount - 1,
							this.pageCount
						];
					} else {
						this.showPages = [
							1,
							'...',
							i - 1,
							i,
							i + 1,
							'...',
							this.pageCount
						];
					}
				} else {
					this.showPages = [1, 2, 3, 4, 5, '...', this.pageCount];
				}
			} else {
				const arr = [...new Array(this.pageCount + 1).keys()]
				arr.splice(0, 1)
				this.showPages = arr
			}
		},
		changeHandle(i) {
			this.$emit('change', i);
		}
	}
};
</script>
<style lang="scss" scoped>
.pagaing {
	margin: 40px auto;
	text-align: center;
	user-select: none;
	.page_item {
		display: inline-block;
		text-align: center;
		line-height: 32px;
		width: 32px;
		height: 32px;
		margin-right: 8px;
		background: #fff;
		border-radius: 2px;
		border: 1px solid rgba(237, 241, 252, 1);
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(59, 59, 88, 0.49);
		cursor: pointer;
		text-decoration: none;
		&.current {
			color: rgba(59, 59, 88, 1);
			background: #ffd200;
			cursor: default;
		}
		&.not-select {
			cursor: default;
			border: none;
			background: none;
		}
	}

	.last-page {
		display: inline-block;
		line-height: 32px;
		// width: 32px;
		height: 32px;
		margin-right: 8px;
		padding: 0 4px;
		background: #fff;
		border-radius: 2px;
		border: 1px solid rgba(237, 241, 252, 1);
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(59, 59, 88, 0.49);
		cursor: pointer;
		text-decoration: none;
	}

	.total {
		display: inline-block;
		font-size:14px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color: rgba(59, 59, 88, 0.49);
		line-height:24px;
		margin-left: 16px;
	}
}
</style>